import script from "./PostersListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PostersListPage.vue?vue&type=script&setup=true&lang=js"

import "./PostersListPage.vue?vue&type=style&index=0&id=e1040ba0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1040ba0"]])

export default __exports__